import Actions from '../../odata/actions';

const actions = new Actions('regulatorySymbol', 'regulatorySymbols');

export default actions;
